
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{ stopsInfo.Titulo_Pagina }}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0 paragensPage">
      <!-- Filtros -->
      <div class="row justify-content-center mb-4 paragensFiltersBlock">
        <div class="col-lg-11 col-12 p-3 bg-secondary bdr-r-10">
          <form [formGroup]="searchForm" *ngIf="searchForm">
            <div class="row">
              <div class="col-lg-4 col-12">
                <label aria-label="Município" class="mb-1 color-white">{{'formLabels.municipio' | translate}}</label>
                <select aria-label="Selecionar Município" formControlName="municipality" class="form-select">
                  <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let municipality of municipalities" value="{{municipality.code}}">{{municipality.name}}</option>
                </select>
              </div>
              <div class="col-lg col-12 align-content-end mt-3 mt-lg-0">
                <div class="search-container">
                  <input type="text" formControlName="text" class="form-control search-input" placeholder="{{'formPlaceholders.pesquisa' | translate}}">
                  <i class="uil uil-search fs-20px search-icon"></i>
                </div>
              </div>
              <div class="col-lg-auto col-12 align-content-end text-end mt-3 mt-lg-0">
                <button (click)="onReset()" title="Limpar Formulário" type="button" class="btn btn-link-white" [disabled]="!isFormValid()"><p class="m-0 fw-600">{{'buttons.limpar' | translate}}<i class="uil uil-backspace fs-20px ms-2 color-white"></i></p></button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- Content -->
      <div class="row justify-content-center paragensInfoContent">
        <div class="col-lg-11 bg-white bdr-r-10">
          <!-- Map && List Stops -->
          <div [hidden]="!searching" class="row justify-content-center page-loading ptb-80"></div>
          <div [hidden]="searching" class="row p-md-4 p-2">
            <div class="col-lg-6 col-12 p-0 map-wrapper">

              <div [hidden]="true" class="map-switcher">
                <button
                  (click)="changeStyle('streets')"
                  [class.active]="currentStyle === 'streets'">
                  {{'common.map' | translate}}
                </button>
                <button
                  (click)="changeStyle('satellite')"
                  [class.active]="currentStyle === 'satellite'">
                  {{'common.satellite' | translate}}
                </button>
              </div>

              <mgl-map
                [style.height]="'500px'"
                [style.width]="'100%'"
                [style]="mapStyle"
                [minZoom]="8"
                [center]="[-8.2261, 41.2069]"
                (zoomEnd)="onZoomChanged()"
                (mapLoad)="onMapLoad($event)"
                [attributionControl]="false">

                <mgl-marker
                  *ngIf="selectedStopData"
                  [lngLat]="[selectedStopData.lng, selectedStopData.lat]"
                  [offset]="markerStyleSelected.offset"
                  [anchor]="'bottom'">

                  <div
                    class="marker-wrapper stop-marker"
                    style="z-index: 9999;"
                    [style.width]="markerStyleSelected.width"
                    [style.height]="markerStyleSelected.height">

                    <img
                      [src]="markerStyleSelected.src"
                      alt="stop"
                      class="marker-image">

                  </div>

                </mgl-marker>

                <mgl-geojson-source
                  id="points-source"
                  [data]="pointsGeoJson"
                  [cluster]="false"
                  [clusterMaxZoom]="14"
                  [clusterRadius]="30">
                </mgl-geojson-source>

                <mgl-layer
                  id="clusters"
                  type="circle"
                  source="points-source"
                  [filter]="['has', 'point_count']"
                  [paint]="{
                    'circle-color': '#00A609',
                    'circle-radius': 20
                  }"
                  (layerClick)="onClusterClick($event)"
                  (layerMouseEnter)="cursorStyle = 'pointer'"
                  (layerMouseLeave)="cursorStyle = ''">
                </mgl-layer>

                <mgl-layer
                  id="cluster-count"
                  type="symbol"
                  source="points-source"
                  [filter]="['has', 'point_count']"
                  [layout]="{
                    'text-field': '{point_count}',  'text-size': 12
                  }"
                  [paint]="{
                    'text-color': '#000'
                  }">>
                </mgl-layer>

                <mgl-layer
                  id="unclustered-point"
                  type="circle"
                  source="points-source"
                  [filter]="['!', ['has', 'point_count']]"
                  [paint]="{
                    'circle-color': [
                      'step', ['zoom'],
                      '#fff',
                      0, '#fff',
                      8, '#fff',
                      10, '#fff',
                      14, '#fff',
                      18, '#fff',
                      20, '#fff'
                    ],
                    'circle-radius': [
                      'interpolate', ['linear'], ['zoom'],
                      0, 1,
                      8, 1,
                      10, 4,
                      14, 5,
                      18, 10,
                      20, 7
                    ],
                    'circle-stroke-width': [
                      'interpolate', ['linear'], ['zoom'],
                      0, 0,
                      8, 1,
                      10, 2,
                      14, 3,
                      18, 4,
                      20, 7
                    ],
                    'circle-stroke-color': [
                      'step', ['zoom'],
                      '#00A609',
                      8, '#00A609',
                      10, '#00A609',
                      14, '#00A609',
                      18, '#00A609',
                      20, '#00A609',
                    ],
                  }"
                  (layerClick)="onPointClick($event)"
                  (layerMouseEnter)="cursorStyle = 'pointer'"
                  (layerMouseLeave)="cursorStyle = ''">
                </mgl-layer>

              </mgl-map>
            </div>
          <div class="col-lg col-12 ms-lg-4 ms-0 p-1 bg-white overflow-y-hidde h500">
            <div *ngIf="stopsFiltered.length == 0" class="noResultsText">{{'stops.semParagensSelecionados' | translate}}</div>
            <p-virtualscroller #TabsContentRef [items]="stopsFiltered" [itemSize]="56" scrollHeight="492px" [virtualScrollItemSize]="66" [showLoader]="true">
                <ng-template #item let-item let-options="options" class="list-unstyled d-grid">
                  <div class="bg-stops-list p-2 mb-2 d-inline-flex w-100 justify-content-between align-items-center"
                    [id]="item['id']" (click)="selectStop(item['id'])" [ngClass]="{'active-stop-stops': selectedStop === item['id'], 'inactive-stop': selectedStop !== item['id']}">
                      <div >
                        <p class="stops-name">{{item['name']}}</p>
                        <p class="stops-municipio">{{item['code']}} ({{'stops.zona' | translate}}: {{item['zone']}})</p>
                      </div>
                      <div class="d-inline-flex align-items-center" *ngIf="selectedStop != item['id']">
                        <p class="bold fs-12px m-0">{{'stops.verParagensBotao' | translate}}</p><i class="uil uil-arrow-down fs-20px ms-2"></i>
                      </div>
                  </div>
                </ng-template>
            </p-virtualscroller>
          </div>
          </div>
          <!-- Info Stops -->
          <div [ngClass]="selectedStop != '' ? 'row paragensInfoBlock' : 'd-none'">
            <div class="col-12 bg-white bdr-r-b-10 p-lg-5 p-3">
              <!-- Filtros -->
              <div class="row mb-3 paragensInfoFilters">

                <div class="col-12 col-lg-6  d-block d-md-inline-flex">
                  <div class="d-inline-flex my-md-auto my-3">
                    <h5 class="m-0">{{ selectedStopText }}</h5>
                  </div>
                </div>

                <ul class="col-12 col-lg-6 list-unstyled d-block d-md-inline-flex justify-content-end m-0">
                  <li class="ms-0 ms-md-3 my-2 my-md-0">
                    <button title="Hoje" type="button" class="btn btn-outline-secondary btn-paragens active" aria-pressed="true"
                            (click)="changeDateToday('today')" [ngClass]="{'active': activeButton === 'today'}">{{'buttons.hoje' | translate}}</button>
                  </li>
                  <li class="ms-0 ms-md-3 my-2 my-md-0">
                    <button title="Amanhã" type="button" class="btn btn-outline-secondary btn-paragens" aria-pressed="true"
                            (click)="changeDateTomorrow('tomorrow')" [ngClass]="{'active': activeButton === 'tomorrow'}">{{'buttons.amanha' | translate}}</button>
                  </li>
                  <li class="ms-0 ms-md-3 my-2 my-md-0 paragensInfoFiltersDatePicker">
                    <button title="Datepicker" class="btn btn-outline-secondary btn-paragens p-0" aria-pressed="true" [ngClass]="{'active': activeButton === 'datepicker'}"
                            (click)="activeButton = 'datepicker'">
                      <input type="text" class="form-control" bsDatepicker [bsValue]="bsValue" [bsConfig]="bsConfig" (bsValueChange)="onDateChange($event, 'datepicker')">
                    </button>
                  </li>
                </ul>
              </div>
              <!-- Info Content -->
              <div #targetSection class="row paragensInfoTables">
                <div class="col-12">
                  <div *ngIf="searchingSchedule" class="row justify-content-center page-loading ptb-80"></div>
                  <ng-container *ngIf="!searchingSchedule && stopSchedule.length > 0" >
                    <div class="table-responsive">
                      <table class="table table-striped mb-0 responsive-table-stops">
                        <thead class="thead-dark">
                        <tr>
                          <th scope="col" [attr.aria-labelledby]="'stops.tabelaLinha' | translate">{{ 'stops.tabelaLinha' | translate }}</th>
                          <th scope="col" [attr.aria-labelledby]="'stops.tabelaDestino' | translate">{{ 'stops.tabelaDestino' | translate }}</th>
                          <th scope="col" [attr.aria-labelledby]="'stops.tabelaPrevisao' | translate">{{ 'stops.tabelaPrevisao' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngIf="showButton" class="btn-tr-view-passed">
                          <td colspan="3" class="text-center">
                            <button class="btn btn-secondary btn-view-passed" (click)="toggleShowPast()">
                              <span *ngIf="!showPast">{{'stops.verPassagensAnteriores' | translate}}</span>
                              <span *ngIf="showPast">{{'stops.esconderPassagensAnteriores' | translate}}</span>
                            </button>
                          </td>
                        </tr>
                        <tr *ngFor="let stop of stopSchedulePastTrue; let isLast = last"  [ngClass]="{ 'bg-passed-schedule': stop['past'], 'last-row': isLast }">
                          <td class="text-start" [attr.data-label]="'stops.tabelaLinha' | translate">
                            <div class="d-inline-flex">
                              <span class="badge uppercase-font my-auto fs-18px h-auto" [ngStyle]="{ 'background-color': stop['routeColor'] }">{{ stop['routeShortName'] }}</span>
                              <i class="uil uil-angle-right-b my-auto mx-2"></i>
                              <p class="my-auto text-end text-lg-start">{{ stop['routeLongName'] }}</p>
                            </div>
                          </td>
                          <td [attr.data-label]="'stops.tabelaDestino' | translate">{{ stop['headsign'] }}</td>
                          <td [attr.data-label]="'stops.tabelaPrevisao' | translate">{{ stop['realtimeArrival'] != undefined ? stop['realtimeArrivalDesc'] : '-' }}</td>
                        </tr>
                        <tr *ngIf="showMyHour" class="tr-passed-button">
                          <td colspan="3" class="text-center">
                            <div class="styles_container">
                              <div class="styles_circle"></div>
                              <div class="styles_line"></div>
                              <div class="styles_mytime">{{'common.myhour' | translate}}</div>
                              <div class="styles_time">{{ hora }}<span>:</span>{{ minutos | number:'2.0' }}</div>
                            </div>
                          </td>
                        </tr>
                        <tr *ngFor="let stop of stopSchedulePastFalse"  [ngClass]="{ 'bg-passed-schedule': stop['past'] }">
                          <td class="text-start" [attr.data-label]="'stops.tabelaLinha' | translate">
                            <div class="d-inline-flex">
                              <span class="badge uppercase-font my-auto fs-18px h-auto" [ngStyle]="{ 'background-color': stop['routeColor'] }">{{ stop['routeShortName'] }}</span>
                              <i class="uil uil-angle-right-b my-auto mx-2"></i>
                              <p class="my-auto text-end text-lg-start">{{ stop['routeLongName'] }}</p>
                            </div>
                          </td>
                          <td [attr.data-label]="'stops.tabelaDestino' | translate">{{ stop['headsign'] }}</td>
                          <td [attr.data-label]="'stops.tabelaPrevisao' | translate">{{ stop['realtimeArrival'] != undefined ? stop['realtimeArrivalDesc'] : '-' }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row mt-3 buttonDownloadPDF">
                      <ul class="col-12 list-unstyled d-inline-flex justify-content-end m-0">
                        <li class="ms-3">
                          <button title="Download PDF" type="button" class="btn btn-outline-secondary btn-download" aria-pressed="true" (click)="generatePdf()">
                            <p class="m-0 fs-12px fw-700 line-height-1-2">{{ 'buttons.download' | translate }}<i class="uil uil-file-download-alt fs-20px ms-2"></i></p>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                  <div *ngIf="!searchingSchedule && stopSchedule.length == 0" class="noResultsText mt-4">
                    {{'stops.semHorariosSelecionados' | translate}}
                    <span *ngIf="selectedStopText != ''">({{ selectedStopText }})</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

